import { render, staticRenderFns } from "./InvoiceNew.vue?vue&type=template&id=f6844c26&scoped=true&"
import script from "./InvoiceNew.vue?vue&type=script&lang=ts&"
export * from "./InvoiceNew.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceNew.vue?vue&type=style&index=0&id=f6844c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6844c26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCheckbox,VForm,VSelect})
